/// <reference types="vite/client" />
/**
 * Runtime environment variable accessor.
 *
 * Priority: window.__ENV__ (injected at container boot via docker-entrypoint.sh
 * replacing the /*WC_ENV*\/{} placeholder in index.html) > import.meta.env
 * (baked at build time, used in local dev with .env.local).
 *
 * Always import via this module — never reach for `import.meta.env` or
 * `window.__ENV__` directly.
 */

type AnalyticsEnv = {
  VITE_API_ENDPOINT: string;
  VITE_FIREBASE_TENANT_ID: string;
};

declare global {
  interface Window {
    __ENV__?: Partial<Record<keyof AnalyticsEnv, string>>;
  }
}

function read(key: keyof AnalyticsEnv): string {
  if (typeof window !== 'undefined') {
    const fromRuntime = window.__ENV__?.[key];
    if (fromRuntime) {
      return fromRuntime;
    }
  }
  const fromBuild = (import.meta.env as Record<string, string | undefined>)[key];
  return fromBuild ?? '';
}

export const env: AnalyticsEnv = {
  VITE_API_ENDPOINT: read('VITE_API_ENDPOINT'),
  VITE_FIREBASE_TENANT_ID: read('VITE_FIREBASE_TENANT_ID'),
};

/**
 * Get the API base URL.
 */
export function getApiBase(): string {
  return env.VITE_API_ENDPOINT || 'http://localhost:3001';
}
